<div class="outer" #outerRef msDimensionsListener [ngStyle]="outerStyle">
  <div class="parts" #partsRef [ngStyle]="partsStyle" msDimensionsListener>
    <ng-content></ng-content>
  </div>
</div>
